import { render, staticRenderFns } from "./ModalAddHC.vue?vue&type=template&id=1c0fce3c&scoped=true"
import script from "./ModalAddHC.vue?vue&type=script&lang=js"
export * from "./ModalAddHC.vue?vue&type=script&lang=js"
import style0 from "./ModalAddHC.vue?vue&type=style&index=0&id=1c0fce3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0fce3c",
  null
  
)

export default component.exports